import $ from 'jquery'
import * as project from './functions'
import './polyfill'

window.onload = () => {
  project.lazyLoad()
  project.smoothScroll()
  project.menuOverlay()
  project.setupModalVideo()
  project.setupAccordion()

  if ($('.slider-init').length > 0) {
    $('.slider-init').each(function() {
      project.setupSlideshow($(this), $(this).data('slick'), $(this).data('slides'))
    })
  }

  const bodyClasses = $('body').attr("class").split(/\s+/)
  
  $.each(bodyClasses, function(key, value) {
    switch(value) {
      case "home":
        project.homeCategoriesMouseover()
        project.toggleSidebar()
        break
      case "page-template-products":
        project.productsTabs()
        break
      default:
        $('#loader').fadeOut(500)
    }
  })
}

$(document).on('facetwp-loaded', function () {
  project.lazyLoad()
})

$(document).on('facetwp-refresh', function () {
  project.lazyLoad()
})